import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import getOrgs from '../../Apis/organisation/getOrgs'
import localStorageHelper from '../../utils/helpers/localStorageHelper'
import getTeams from '../../Apis/team/getTeams'
import useQueryParams from '../../hooks/useQueryParams'
import QueryKeys from '../../utils/constants/queryKeys'
import useHistoryPush from '../../hooks/useHistoryPush'
import localStorageIds from '../../utils/constants/localStorageIds'
import storableOrg from '../../utils/helpers/storableOrg'
import ORGANISATION_TYPES from '../../utils/constants/OrganisationTypes'
import isStatistician from '../../utils/helpers/isStatistician'

const SetUrlAfterLogin = () => {
  const [org, setOrg] = useState('')
  const { redirect } = useHistoryPush()
  const queryParams = useQueryParams()
  const { pathname } = useHistoryPush()
  const orgLocalStorageHelper = localStorageHelper(localStorageIds.SELECTED_ORG)
  const teamLocalStorageHelper = localStorageHelper(localStorageIds.SELECTED_TEAM)

  const orgIsCompetitionOrFederation =
    org?.type === ORGANISATION_TYPES.ORG_COMPETITION ||
    org?.type === ORGANISATION_TYPES.ORG_FEDERATION

  // Clean organisation after logout
  useEffect(
    () => () => {
      setOrg('')
    },
    [],
  )

  const HAS_ORGS = 'hasOrgs'
  const HAS_NO_ORGS = 'noOrgs'

  const ON_GET_ORGS_SUCCESS = {
    [HAS_ORGS]: (data) => {
      const oldUrlOrgId = queryParams?.org || orgLocalStorageHelper?.localStorageValue?.id
      const existingOrg = data.find((c) => c.id === oldUrlOrgId)

      setOrg(existingOrg || data[0])
      orgLocalStorageHelper.setLocalStorageValue(storableOrg(existingOrg || data[0]))
    },
    [HAS_NO_ORGS]: () => {
      // Remove ths organisation and the team from local storage

      orgLocalStorageHelper.removeLocalStorageValue()
      teamLocalStorageHelper.removeLocalStorageValue()
    },
  }

  useQuery([QueryKeys.GET_ORGS_AFTER_LOGIN], () => getOrgs(), {
    onSuccess: (orgs) => {
      if (orgs.length > 0) {
        ON_GET_ORGS_SUCCESS[HAS_ORGS](orgs)
      } else {
        ON_GET_ORGS_SUCCESS[HAS_NO_ORGS]()
      }
    },
  })

  const HAS_EXISTING_TEAM = 'hasExistingTeam'
  const HAS_ONLY_ONE_TEAM = 'hasOnlyOneTeam'
  const HAS_NO_TEAMS = 'noTeams'

  const ON_GET_TEAMS_SUCCESS = {
    [HAS_EXISTING_TEAM]: (existingTeam, newPathnameTeam) => {
      teamLocalStorageHelper.setLocalStorageValue(existingTeam)
      redirect(`${newPathnameTeam}`, [{ org: org?.id }, { team: existingTeam.id }])
    },
    [HAS_ONLY_ONE_TEAM]: (data, newPathnameTeam) => {
      redirect(`${newPathnameTeam}`, [{ org: org?.id }, { team: data[0].id }])
      teamLocalStorageHelper.removeLocalStorageValue(data[0])
    },
    [HAS_NO_TEAMS]: (newPathname) => {
      redirect(`${newPathname}`, [{ org: org?.id }])
      teamLocalStorageHelper.removeLocalStorageValue()
    },
  }

  useEffect(() => {
    if (orgIsCompetitionOrFederation && org?.id) {
      const newPathname = pathname === '/' ? (isStatistician() ? '/profile' : '/calendar') : pathname
      redirect(`${newPathname}`, [{ org: org?.id }])
    }
  }, [org?.id, orgIsCompetitionOrFederation])

  useQuery([QueryKeys.GET_TEAMS_AFTER_LOGIN, org?.id], () => getTeams(org?.id), {
    enabled: Boolean(!orgIsCompetitionOrFederation && org?.id),
    onSuccess: (data) => {
      const newPathname = pathname === '/' ? (isStatistician() ? '/profile' : '/calendar') : pathname
      const newPathnameTeam = pathname === '/' ? (isStatistician() ? '/profile' : '/teamCalendar') : pathname

      // TODO: Add mapper
      if (
        !data?.length || orgIsCompetitionOrFederation
      ) {
        return ON_GET_TEAMS_SUCCESS[HAS_NO_TEAMS](newPathname)
      }

      const oldUrlTeamId = queryParams?.team || teamLocalStorageHelper?.localStorageValue?.id
      const existingTeam = data?.find((team) => team.id === oldUrlTeamId)

      if (existingTeam) {
        return ON_GET_TEAMS_SUCCESS[HAS_EXISTING_TEAM](existingTeam, newPathnameTeam)
      }

      if (data?.length === 1) {
        return ON_GET_TEAMS_SUCCESS[HAS_ONLY_ONE_TEAM](data, newPathnameTeam)
      }

      return redirect(`${newPathname}`, [{ org: org?.id }])
    },
  })

  return null
}

export default SetUrlAfterLogin
